import Link from 'next/link';
export const RaceForRewardsCreator = ({ creator }) => {
    return (<Link href={creator.url} passHref>
			<a>
				<div className="my-8 flex cursor-pointer">
					<Image creator={creator}/>
					<div className="m-2">
						<DisplayName creator={creator}/>
						<CreatorDetails creator={creator}/>
					</div>
				</div>
			</a>
		</Link>);
};
const Image = ({ creator }) => (<img src={creator.avatar} alt={creator.displayName} className="w-[50px] h-[50px] rounded-full shadow-green-glow m-2"/>);
const DisplayName = ({ creator }) => (<div>
		<span className="text-xl font-medium">{creator.displayName}</span>
	</div>);
const CreatorDetails = ({ creator }) => (<div className="flex items-center justify-center">
		<span className="uppercase text-sm text-tertiary mx-1">Followers:</span>
		<span className="text-l font-medium mx-1">{creator.followerCount.toLocaleString()}</span>
		<span className="uppercase text-sm text-tertiary mx-1">Total dares:</span>
		<span className="text-l font-medium mx-1">{creator.deliveryCount}</span>
	</div>);
